import { render, staticRenderFns } from "./parent-forbid.vue?vue&type=template&id=371c6c64&scoped=true&"
import script from "./parent-forbid.vue?vue&type=script&lang=js&"
export * from "./parent-forbid.vue?vue&type=script&lang=js&"
import style0 from "./parent-forbid.vue?vue&type=style&index=0&id=371c6c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c6c64",
  null
  
)

export default component.exports